import React, {Component} from 'react';
import {Modal} from "antd";
import { TYPE_TIRES, TYPE_WHEELS } from "../../../public/journey1/definition/business";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";
import SwitchPlanning from "./SwitchPlanning";

class SwitchPlanningSlotsModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      slot: {},
      errors: {}
    }
  }

  onModalClose = () => {
    const {dispatchShowSwitchWheelsTiresModal} = this.props;
    dispatchShowSwitchWheelsTiresModal(false);
  };

  onSave = () => {
    const {slot} = this.state;
    const {onSave} = this.props;
    onSave(slot);
  };

  getSwitchType = (type) => type === TYPE_WHEELS ? TYPE_TIRES : TYPE_WHEELS;

  render() {
    const {intl: {formatMessage}, type, day, onUpdate, onChangeDate, visible} = this.props;

    return (
      <Modal
        title={formatMessage({id: `section.exchange-management.${this.getSwitchType(type)}.title`})}
        visible={visible}
        onCancel={this.onModalClose}
        onOk={this.onSave}
        width={1100}
      >
        <SwitchPlanning day={day} index={0} type={this.getSwitchType(type)} onUpdate={onUpdate} onChangeDate={onChangeDate} />
      </Modal>
    )
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatchShowSwitchWheelsTiresModal: show => dispatch({type: `SHOW_SWITCH_${ownProps.type}_SLOTS_MODAL`, show}),
});

export default withRouter(
  connect(
    () => {},
    mapDispatchToProps
  )(injectIntl(SwitchPlanningSlotsModal))
);
